export default {
  // Splash & Onboarding
  "welcome": "مرحباً بك",
  "onboarding1_title": "نقل آمن وسريع",
  "onboarding1_desc": "خدمة نقل المركبات والبضائع بأحدث السطحات وأفضل السائقين",
  "onboarding2_title": "تتبع مباشر",
  "onboarding2_desc": "تابع موقع سطحتك لحظة بلحظة حتى وصول مركبتك بأمان",
  "onboarding3_title": "أسعار شفافة",
  "onboarding3_desc": "احصل على سعر فوري قبل تأكيد الطلب بدون مفاجآت",
  "next": "التالي",
  "skip": "تخطي",
  "get_started": "ابدأ الآن",
  
  // Language
  "select_language": "اختر اللغة",
  "arabic": "العربية",
  "english": "English",
  "continue": "متابعة",
  
  // Auth
  "login": "تسجيل الدخول",
  "phone_number": "رقم الجوال",
  "enter_phone": "أدخل رقم جوالك",
  "send_code": "إرسال الرمز",
  "enter_otp": "أدخل رمز التحقق",
  "otp_sent": "تم إرسال رمز التحقق إلى",
  "verify": "تحقق",
  "resend_code": "إعادة إرسال الرمز",
  "guest_mode": "الدخول كزائر",
  "guest_explore": "استكشف جميع المميزات",
  
  // Home
  "home": "الرئيسية",
  "orders": "الطلبات",
  "profile": "الملف الشخصي",
  "where_pickup": "من أين نستلم؟",
  "where_dropoff": "إلى أين نوصل؟",
  "use_current_location": "استخدام موقعي الحالي",
  "saved_addresses": "العناوين المحفوظة",
  "home_address": "المنزل",
  "work_address": "العمل",
  "search_address": "ابحث عن عنوان...",
  "request_flatbed": "اطلب سطحة",
  
  // Order Details
  "order_details": "تفاصيل الطلب",
  "vehicle_info": "معلومات المركبة",
  "vehicle_type": "نوع المركبة",
  "select_type": "اختر النوع",
  "car": "سيارة",
  "suv": "دفع رباعي",
  "truck": "شاحنة صغيرة",
  "heavy_truck": "شاحنة كبيرة",
  "motorcycle": "دراجة نارية",
  "vehicle_model": "موديل المركبة",
  "enter_model": "أدخل الموديل",
  "upload_photos": "رفع صور المركبة",
  "front_photo": "صورة أمامية",
  "back_photo": "صورة خلفية",
  "side_photo": "صورة جانبية",
  "add_photo": "إضافة صورة",
  "notes": "ملاحظات إضافية",
  "enter_notes": "أضف أي ملاحظات خاصة...",
  "get_quote": "احصل على السعر",
  
  // Instant Quote
  "instant_quote": "السعر الفوري",
  "distance": "المسافة",
  "km": "كم",
  "estimated_time": "الوقت المتوقع",
  "minutes": "دقيقة",
  "base_price": "السعر الأساسي",
  "sar": "ريال",
  "additional_services": "خدمات إضافية",
  "winch_service": "خدمة الونش",
  "vehicle_cover": "تغطية المركبة",
  "insurance": "تأمين إضافي",
  "total_price": "السعر الإجمالي",
  "confirm_order": "تأكيد الطلب",
  "edit_details": "تعديل التفاصيل",
  
  // Finding Driver
  "finding_driver": "جاري البحث عن سائق...",
  "please_wait": "يرجى الانتظار",
  "searching_nearest": "نبحث عن أقرب سائق متاح",
  
  // Driver Accepted
  "driver_accepted": "تم قبول الطلب",
  "driver_info": "معلومات السائق",
  "rating": "التقييم",
  "flatbed_type": "نوع السطحة",
  "plate_number": "رقم اللوحة",
  "call_driver": "اتصال",
  "chat": "محادثة",
  "share_location": "مشاركة الموقع",
  "order_status": "حالة الطلب",
  "on_the_way": "في الطريق إليك",
  "arrived": "وصل الموقع",
  "loading": "جاري التحميل",
  "in_transit": "في الطريق للوجهة",
  "delivered": "تم التسليم",
  "track_live": "تتبع مباشر",
  
  // Trip Complete
  "trip_complete": "اكتملت الرحلة",
  "trip_summary": "ملخص الرحلة",
  "pickup_location": "موقع الاستلام",
  "dropoff_location": "موقع التسليم",
  "trip_duration": "مدة الرحلة",
  "rate_driver": "قيّم السائق",
  "rate_experience": "كيف كانت تجربتك؟",
  "add_comment": "أضف تعليق (اختياري)",
  "submit_rating": "إرسال التقييم",
  "share_receipt": "مشاركة الفاتورة",
  "done": "تم",
  
  // Orders List
  "current_orders": "الطلبات الحالية",
  "past_orders": "الطلبات السابقة",
  "cancelled_orders": "الطلبات الملغاة",
  "no_orders": "لا توجد طلبات",
  "order_id": "رقم الطلب",
  "status": "الحالة",
  "view_details": "عرض التفاصيل",
  "pending": "قيد الانتظار",
  "in_progress": "جاري التنفيذ",
  "completed": "مكتمل",
  "cancelled": "ملغي",
  
  // Profile
  "personal_info": "المعلومات الشخصية",
  "full_name": "الاسم الكامل",
  "email": "البريد الإلكتروني",
  "saved_locations": "المواقع المحفوظة",
  "add_address": "إضافة عنوان",
  "notifications": "الإشعارات",
  "enable_notifications": "تفعيل الإشعارات",
  "language": "اللغة",
  "privacy_policy": "سياسة الخصوصية",
  "terms_conditions": "الشروط والأحكام",
  "faq": "الأسئلة الشائعة",
  "logout": "تسجيل الخروج",
  "save": "حفظ",
  "cancel": "إلغاء",
  
  // Chat
  "type_message": "اكتب رسالة...",
  "send": "إرسال",
  
  // Errors
  "error_occurred": "حدث خطأ",
  "connection_error": "خطأ في الاتصال",
  "check_connection": "يرجى التحقق من اتصالك بالإنترنت",
  "retry": "إعادة المحاولة",
  
  // Common
  "back": "رجوع",
  "close": "إغلاق",
  "delete": "حذف",
  "edit": "تعديل",
  "add": "إضافة",
  "search": "بحث",
  "filter": "تصفية",
  "sort": "ترتيب",
  "apply": "تطبيق",
  "reset": "إعادة تعيين",
  "yes": "نعم",
  "no": "لا",
  "ok": "موافق",
};